import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

type Screens = {
  sm: string;
  md: string;
  lg: string;
  xl: string;
  '2xl': string;
};

type ScreensPixelValues = {
  sm: number;
  md: number;
  lg: number;
  xl: number;
  '2xl': number;
};

export function useTailwindBreakpoints(): {
  screens: Ref<Screens>;
  screenPixelValues: Ref<ScreensPixelValues>;
} {
  const fullConfig = resolveConfig(tailwindConfig as any);

  const screens = fullConfig.theme.screens as Screens;
  const screenPixelValues: ScreensPixelValues = {
    sm: +screens.sm.replace('px', ''),
    md: +screens.md.replace('px', ''),
    lg: +screens.lg.replace('px', ''),
    xl: +screens.xl.replace('px', ''),
    '2xl': +screens['2xl'].replace('px', ''),
  };

  return {
    screens: shallowRef<Screens>(screens),
    screenPixelValues: shallowRef<ScreensPixelValues>(screenPixelValues),
  };
}
